
import Headings from "./Headings.vue";
import EndMessage from "./EndMessage.vue";
import WfPetImg from "./WfPetImg.vue";

export default {
	components: {
		WfPetImg,
		Headings,
		EndMessage,
	},
};
